import { useEffect } from "react";
import { IPushNotificationProvider } from "../hexagon/adapters/driven/providers/pushNotificationProvider";

interface IUseFCMTokenUpdate {
  electronEngineProvider: IElectronEngineProvider;
  pushNotificationProvider: IPushNotificationProvider;
}

export const useFCMTokenUpdate = ({
  electronEngineProvider,
  pushNotificationProvider,
}: IUseFCMTokenUpdate) => {
  useEffect(() => {
    let listenerUnsub: (() => void) | null = null;
    if (electronEngineProvider.isWindowElectron()) {
      listenerUnsub = window.electron.listenToFCMToken(async () => {
        await pushNotificationProvider.registerDeviceForPushNotifications();
      });
    }
    return () => {
      if (listenerUnsub) {
        listenerUnsub();
      }
    };
  }, []);

  return null;
};
